import { createSvgIcon } from '@material-ui/core';

// Material Icon https://fonts.google.com/icons?selected=Material+Symbols+Outlined:task_alt:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=task_alt&icon.size=24&icon.color=%23e3e3e3
export const TaskAltIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z" />
  </svg>,
  'TaskAltIcon',
);
